import { usePrevious } from '@patrianna/shared-hooks'
import { getAuthFlowLoadingSelector } from '@patrianna/shared-store/auth'
import { useEffect, useRef } from 'react'
// @ts-ignore
import { usePageVisibility } from 'react-page-visibility'

import { appStateActiveHandler, appStateInactiveHandler } from 'services/websocket'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { getConfirmedKycInfo } from 'store/modules/kyc/actions'
import { getAccountInfo } from 'store/modules/user/actions'

const DELAY = 1000 * 60 // 1 minute

export default function VisibilityProvider(): null {
  const isVisible = usePageVisibility()
  const dispatch = useAppDispatch()
  const isPrevVisible = usePrevious(isVisible)
  const isAuthFlow = useAppSelector(getAuthFlowLoadingSelector)
  const timeLeftTab = useRef<number | null>(null)

  useEffect(() => {
    if (isAuthFlow) {
      return undefined
    }

    // tab becomes inactive
    if (!isVisible) {
      timeLeftTab.current = Date.now()

      // If tab becomes inactive then we need to set a timer to check
      // if it was inactive for more than DELAY that we need to disconnect WS
      // https://patrianna.atlassian.net/browse/FE-276
      const timerId = setTimeout(() => {
        dispatch(appStateInactiveHandler())
      }, DELAY)

      return () => {
        clearTimeout(timerId)
      }
    } else {
      // tab becomes active
      dispatch(appStateActiveHandler())

      // If we back to the tab then need to check if it was inactive for more than DELAY minute
      // and if it was then we need to fetch account info
      if (!isPrevVisible && timeLeftTab.current !== null && Date.now() - timeLeftTab.current > DELAY) {
        dispatch(getAccountInfo())
        dispatch(getConfirmedKycInfo())
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible])

  return null
}
